<template>
  <svg
    :style="spinnerStyle"
    :class="styles.spinner"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    role="status"
    aria-label="Загрузка"
    focusable="false"
  >
    <circle :class="styles.track" cx="24" cy="24" r="20" />
    <g>
      <path :class="styles.arc" d="M 24 4 A 20 20 0 0 1 44 24" />
      <!-- Animate the SVG group directly, independently of CSS transforms/keyframes. -->
      <animateTransform
        ref="rotation"
        attributeName="transform"
        type="rotate"
        from="0 24 24"
        to="360 24 24"
        dur="0.9s"
        repeatCount="indefinite"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
import { computed, onMounted, onBeforeUnmount, ref } from 'vue';

import styles from './styles.module.css';

export interface SpinnerProps {
  size?: number | string;
  color?: 'primary' | 'white';
}

const props = withDefaults(defineProps<SpinnerProps>(), { size: '20px', color: 'primary' });

const rotation = ref<SVGAnimateTransformElement | null>(null);
let animationFrame = 0;

onMounted(() => {
  // Restart the SVG timeline when Vue mounts a cloned or previously removed loader.
  animationFrame = requestAnimationFrame(() => rotation.value?.beginElement());
});

onBeforeUnmount(() => cancelAnimationFrame(animationFrame));

const spinnerStyle = computed(() => {
  let colorStyle = {};
  if (props.color === 'primary') {
    colorStyle = {
      '--spinner-color': '#0C79FF',
      '--spinner-track-color': '#afd2fd',
    };
  } else if (props.color === 'white') {
    colorStyle = {
      '--spinner-color': '#FFFFFF',
      '--spinner-track-color': '#FFFFFF99',
    };
  }

  return {
    ...colorStyle,
    '--spinner-size': isNaN(props.size as number) ? props.size : `${props.size}px`,
  };
});
</script>
